<div (click)="snackbar.dismiss()">
	<h3>{{'alertView.warningTitle' | translate}}: {{'alertView.sessionExpirationWarning' | translate}}</h3>
	<p>{{idleState}}</p>
</div>
